export const analyticsWrapper = {
  margin: "20px",
  height: "350px",
};

export const defaultTabStyle = {
    background: '#EEEEEE',
    borderRadius: '8px',
    color: "#757575",
}

export const selectedTabStyle = {
    background: 'linear-gradient(90deg, #044F82 0%, #2C96DE 100%)',
    borderRadius: '0 8px 8px 0',
    color: "#ffffff", 
}
